<template>
  <section
    style="
      padding-left: 25px;
      margin-left: 20px;
      padding-right: 10px;
      margin-right: 10px;
    "
  >
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-row>
          <v-col cols="12" sm="12" md="3">
            <v-btn @click="addCard = !addCard" class="info ml-6 mr-2 mt-4">
              <v-icon left> {{ icons.mdiDatabasePlusOutline }} </v-icon>
              Ajouter un nouveau duaa
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="addCard">
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-1">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-title>Ajouter un nouveau duaa</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="duaaName"
                    label="Titre"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="duaaNameEn"
                    label="Titre en anglais"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                

                <v-col cols="12" sm="12" md="6">
                  <label class="subtitle-2 font-weight-medium" style="display:block; margin-bottom:8px;">Description</label>
                  <VueEditor
                    v-model="duaaDescription"
                    auto-grow
                    outlined
                    placeholder="Description"
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <label class="subtitle-2 font-weight-medium" style="display:block; margin-bottom:8px;">Description en anglais</label>
                  <VueEditor
                    v-model="duaaDescriptionEn"
                    auto-grow
                    outlined
                    placeholder="Description en anglais"
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <vue-upload-multiple-image
                    v-if="duaaName && duaaDescription && duaaNameEn && duaaDescriptionEn"
                    style="margin-left: 160px"
                    v-model="images"
                    :data-images="images"
                    accept="image/*	"
                    name="images"
                    drag-text="Veuillez ajoutez une images svp!"
                    browse-text="Browse image"
                    primary-text="Primary image"
                    mark-is-primary-text="Set default image"
                    :min-image="1"
                    :multiple="false"
                    :loading="load"
                    popup-text="Description default image"
                    drop-text="Drag and drop"
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                    @images-updated="handleImagesUpdated"
                  >
                  </vue-upload-multiple-image>

                  <v-progress-linear
                    v-if="showlowding && uploadPercentage < 100"
                    style="
                      max-width: 190px;
                      margin-left: 160px;
                      pointer-events: none;
                    "
                    color="primary"
                    indeterminate
                    rounded
                    :clickable="false"
                    height="15"
                    ><strong
                      >{{ Math.ceil(uploadPercentage) }}%</strong
                    ></v-progress-linear
                  >
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="rankduaa"
                    hide-details
                    outlined
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    label="Rank duaa"
                  />
                </v-col>

                <v-col cols="auto" style="margin-top: 16px">
                  <span>Premium:</span>
                </v-col>
                <v-col cols="auto">
                  <v-switch v-model="isLocked" hide-details inset></v-switch>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      :disabled="
                        rankduaa.length <= 0 ||
                        duaaName.length <= 0 ||
                        duaaDescription.length <= 0 ||
                        duaaNameEn.length <= 0 ||
                        duaaDescriptionEn.length <= 0 ||
                        !duaa.imgDBUrlId
                      "
                      class="info"
                      @click="validate"
                      :loading="isButtonLoading"
                    >
                      {{ isButtonLoading ? "Chargement..." : "Suivant" }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-card-title>
        <p>Liste des duaa</p>
      </v-card-title>

      <v-text-field
        style="padding: 15px"
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        clearable
        :search="search"
      ></v-text-field>

      <v-data-table
        :search="search"
        :loading="isLoadingTables"
        :headers="headers"
        :items="duaaArray"
        class="elevation-1"
        item-key="id"
        loading-text="Loading..."
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 30],
        }"
      >
        <!-- <template v-slot:item.imageUrl="{ item }">
          <v-img style="margin: 10px" :src="item.imageUrl" width="65" height="65" />
          <v-divider></v-divider>
        </template> -->

        <template v-slot:[`item.imageUrl`]="{ item }">
          <v-img
            v-if="item.imgDBType != 'svg'"
            :src="item.imgUrl"
            width="65"
            height="65"
          />
          <div
            v-if="item.imgDBType === 'svg'"
            v-html="item.svgContent"
          ></div>

          <v-divider></v-divider>
        </template>
        <template v-slot:[`item.isLocked`]="{ item }">
          <v-icon color="warning" v-if="item.isLocked">
            {{ icons.mdiLock }}
          </v-icon>
          <v-icon color="#00a325" v-if="!item.isLocked">
            {{ icons.mdiLockOpen }}
          </v-icon>
        </template>
        <template v-slot:[`item.modifier`]="{ item }">
          <v-icon @click="redirectToEditProduct(item)">
            {{ icons.mdiPencil }}
          </v-icon>
        </template>

        <template v-slot:[`item.supprimer`]="{ item }">
          <v-icon @click="suppressionAction(item.id)">
            {{ icons.mdiDeleteOutline }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogAddduaa" max-width="530">
        <v-card class="pa-6 pa-sm-6" max-width="600px">
          <v-card-title style="text-align: center" class="justify-center mb-2"
            >Etes vous sur de vouloir ajouter le duaa
          </v-card-title>
          <v-card-subtitle
            class="text-h6 mb-3"
            style="text-align: center; color: #24aeb1"
            >{{ duaaName }}
          </v-card-subtitle>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="ajoutduaa()"
              :color="loadingbtn ? 'grey' : 'info'"
              :disabled="loadingbtn"
            >
              <span v-if="!loadingbtn">Confirmer</span>
              <v-progress-circular
                v-if="loadingbtn"
                size="24"
                color="white"
                indeterminate
              ></v-progress-circular>
            </v-btn>
            <v-btn
              :color="loadingbtn ? 'grey' : 'error'"
              :disabled="loadingbtn"
              @click="reinitialisationFormulaire()"
            >
              <span v-if="!loadingbtn">Annuler</span>
              <v-progress-circular
                v-if="loadingbtn"
                size="24"
                color="white"
                indeterminate
              ></v-progress-circular>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogDeleteduaa" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir supprimer le duaa ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="dialogDeleteduaa = false"
            >
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="deleteduaa()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </section>
</template>
<script>
import store from "../../../store/image";

import { component as VueCodeHighlight } from "vue-code-highlight";
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import {
  mdiLockOpen,
  mdiLock,
  mdiPlus,
  mdiDeleteOutline,
  mdiPencil,
  mdiDatabasePlusOutline,
} from "@mdi/js";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import Constant from "@/utils/constants";
import { getAllduaa } from "@/views/qorani/services/services";
import { mapState } from "vuex";
import axios from "axios";
export default {
  components: { VueUploadMultipleImage, VueEditor, VueCodeHighlight },
  data() {
    return {
      search: "",
      uploadPercentage: null,
      showlowding: false,
      addCard: false,
      loadingbtn: false,
      icons: {
        mdiLockOpen,
        mdiLock,
        mdiPlus,
        mdiDeleteOutline,
        mdiPencil,
        mdiDatabasePlusOutline,
      },
      isLocked: false,
      valid: true,
      rankduaa: "",
      duaaName: "",
      duaaNameEn: "",
      suratName: "",
      duaaDescription: "",
      duaaDescriptionEn: "",
      numVerset: "",
      duaa: {
        title: "",
        description: "",
        imgDBUrlId: "",
        rank: "",
      },
      loadingAddJuz: false,
      dialogAddduaa: false,
      duaaArray: [],
      isLoadingTables: false,
      loading: true,
      headers: [
        { text: "Image", value: "imageUrl" },
        { text: "Titre", value: "title" },
        { text: "Titre En", value: "titleEn", align: "center" },
        { text: "Description", value: "description", align: "center" },
        { text: "Description En", value: "descriptionEn", align: "center" },
        { text: "Rank", value: "rank", align: "center" },
        { text: "Premium", value: "isLocked" },
        { text: "Modifier", value: "modifier", align: "center" },
        { text: "Supprimer", value: "supprimer", align: "center" },
      ],
      dialogDeleteduaa: false,
      dialogConfirmEditduaa: false,
      loadingEditJuz: false,
      images: [],
      load: false,
      showLoading: false,
      imagesUpload: [],
      imageUrl: "",
      // imageId: "",
      isButtonLoading: false,
      idduaaSupprimmer: "",
      duaaEdit: [],
      fakePercentage: null,
      imageInfo: {
        fileName: "",
        fileUrl: "",
      },
    };
  },
  computed: {
    ...mapState(["imageId"]),
  },
  methods: {
    async loadImage(item) {
      if (item.imgDBType === "svg") {
        try {
          const response = await fetch(
            `${Constant.QORANI}fileDB/files/${item.imgDBId}`
          );
          if (!response.ok)
            throw new Error("Échec du chargement de l'image SVG");

          let svgContent = await response.text();

          // Ajoute width et height directement dans le SVG
          svgContent = svgContent
            .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

          this.$set(item, 'svgContent', svgContent);
        } catch (error) {
          console.error("Erreur lors du chargement de l'image :", error);
        }
      } else {
        this.$set(item, 'imgUrl', `${Constant.QORANI}fileDB/files/${item.imgDBId}`);
      }
    },

    getImageUrl(imgDBId) {
      return `${Constant.QORANI}fileDB/files/${imgDBId}`;
    },
    redirectToEditProduct(item) {
      this.$router.push({
        name: "EditDuaa",
        params: { id: item.id, item: item },
      });
    },
    suppressionAction(item) {
      this.idduaaSupprimmer = item;
      // this.dialogDeleteduaa = true;
      this.deleteduaa();
    },
    async deleteduaa() {
      const responseCategorie = await fetch(
        Constant.QORANI + `duaa/delete/${this.idduaaSupprimmer}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      try {
        this.dialogDeleteduaa = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la suppression du juz, veuillez réessayez plus tard, Merci."
        );
        this.dialogDeleteduaa = false;
      }
    },
    async ajoutduaa() {
      this.loadingbtn = true;
      const imageId = store.state.imageId;
      // console.log("id", imageId);
      this.duaa.title = this.duaaName;
      this.duaa.titleEn = this.duaaNameEn;
      this.duaa.description = this.duaaDescription;
      this.duaa.descriptionEn = this.duaaDescriptionEn;
      this.duaa.rank = this.rankduaa;
      this.duaa.isLocked = this.isLocked;

      const responseCategorie = await fetch(Constant.QORANI + "duaa/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.duaa),
      });

      try {
        this.reinitialisationFormulaire();
        // window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de l'ajout du duaa, veuillez réessayez plus tard, Merci."
        );
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        // this.dialogAddduaa = true;
        this.ajoutduaa();
      }
    },
    reinitialisationFormulaire() {
      this.dialogAddduaa = false;
      this.imageId = "";
      this.imageUrl = "";
      this.images = [];
      this.imagesUpload = [];
      this.$refs.form.reset();
    },

    handleImagesUpdated(images) {
      const uploadedImage = images[0];
      // console.log("Uploaded image:", uploadedImage);
    },

    async uploadImageSuccess(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccess", {
          formData,
          index,
          fileList,
        });
        const imageId = store.state.imageId;
        this.duaa.imgDBUrlId = imageId;

        // console.log("Image id :", imageId);
      } catch (error) {
        // console.error("Failed to upload image:", error);
      }
    },

    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.fakePercentage = 0;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.imagesUpload.indexOf(
          fileList[index].path
        );
        this.imageUrl = "";
        this.imageId = "";
        this.duaa.imgDBUrlId = "";
        if (index > -1) {
          this.imagesUpload.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
  },

  async created() {
    this.isLoadingTables = true;
    this.duaaArray = await getAllduaa();
    this.duaaArray.forEach(async (item) => {
      console.log(item);

      if (item.imgDBId) {https://chartdb.io/
        await this.loadImage(item);
      }
    });
    this.isLoadingTables = false;
  },
};
</script>
<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>
